import React, { Component } from 'react';
import TableHeader from './TableHeader';
import styles from './ProjectsTable.module.scss';
import ProjectTableLine from './ProjectTableLine';
import { getSortedList } from './utils';

interface Props {
  projectsList: any[];
  projectId?: string;
  className?: string;
  flatTable?: boolean;
  setProjectList?: (list: any[]) => void;
}

export interface ProjectsTableState {
  arrangeByName: 'ascending' | 'descending';
  arrangeByType: 'ascending' | 'descending';
  arrangeByAddedDate: 'ascending' | 'descending';
  arrangeByGenre: 'ascending' | 'descending';
  arrangeOrder: string[];
}

class ProjectsTable extends Component<Props, ProjectsTableState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      arrangeByName: 'ascending',
      arrangeByType: 'ascending',
      arrangeByAddedDate: 'ascending',
      arrangeByGenre: 'ascending',
      arrangeOrder: ['name', 'date', 'genre']
    };
  }

  handleRemoveLine(id: number) {
    const { setProjectList, projectsList } = this.props;
    if (!setProjectList) return;

    setProjectList([...projectsList].filter(p => p.id !== id));
  }

  render() {
    const { projectId, projectsList, className, flatTable } = this.props;
    const projectsFiltered = projectId
      ? projectsList.filter(project => project.id.toString() === projectId)
      : projectsList;

    const sortedList = getSortedList(projectsFiltered, this.state);

    const containerStyles = [styles.container];
    flatTable && containerStyles.push(styles.flatTable);
    className && containerStyles.push(className);

    return (
      <div className={containerStyles.join(' ')}>

        <TableHeader
          {...this.state}
          setState={this.setState.bind(this)}
          flatTable={flatTable}
        />

        <div className={styles.scrollable}>
          {sortedList.map(project =>
            <ProjectTableLine
              key={project.id}
              project={project}
              flatTable={flatTable}
              arrangeState={this.state}
              removeLine={() => this.handleRemoveLine(project.id)}
            />
          )}
        </div>

      </div>
    );
  }
}

export default ProjectsTable;
